import { Record } from 'immutable';

const LookAndFeel = Record({
	headings: null,
	header: null,
	content: null,
});

export default LookAndFeel;
